import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import axios from "axios";

const FeaturedGymSlice = createSlice({
  name: "FeaturedGym",

  initialState: {
    featuredGymData: [],
    isLoading: true,
    isError: false,
  },

  reducers: {
    fetchFeaturedGymStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchFeaturedGymSuccess: (state, action) => {
      state.isLoading = false;
      state.featuredGymData = action.payload;
    },
    fetchFeaturedGymFailure: (state, action) => {
      state.isLoading = false;
      state.isError = action.payload;
    },
  },
});

export const {
  fetchFeaturedGymStart,
  fetchFeaturedGymSuccess,
  fetchFeaturedGymFailure,
} = FeaturedGymSlice.actions;

export const fetchFeaturedGym = () => async (dispatch, getState) => {
  const { FeaturedGym } = getState();
  if (FeaturedGym.featuredGymData.length > 0) {
    return;
  }
  dispatch(fetchFeaturedGymStart());

  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchFeaturedGymSuccess(response.data.feature_list || []));
  } catch (error) {
    dispatch(fetchFeaturedGymFailure(error));
  }
};

export default FeaturedGymSlice.reducer;
